import { useQuery } from '@tanstack/react-query';

import { sdk } from '@/services';

const FlashcardCollectionService = sdk.getService('FlashcardCollectionService');

export const useAllFlashcardsCoursesForSelectors = () => {
  const { isLoading, data, error } = useQuery({
    queryKey: ['courses', 'flashcards'],
    queryFn: () => FlashcardCollectionService.findAllFlashcardsCoursesForSelectors()
  });

  return {
    courses: data,
    isLoading,
    error
  };
};
